import { createContext as createContext$1, useContext } from 'react';

function createContext(options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? true : _options$strict,
      _options$errorMessage = _options.errorMessage,
      errorMessage = _options$errorMessage === void 0 ? 'useContext must be inside a Provider with a value' : _options$errorMessage,
      name = _options.name;
  var Context = createContext$1(undefined);
  Context.displayName = name;

  function useContext$1() {
    var context = useContext(Context);

    if (!context && strict) {
      throw new Error(errorMessage);
    }

    return context;
  }

  return [Context.Provider, useContext$1, Context];
}

export default createContext;
//# sourceMappingURL=context.esm.js.map
